var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac-job-detail--desktop-3",
    transform: "translate(-118.000000, -138.000000)",
    fillRule: "nonzero",
    fill: "#13B57D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(98.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5653768,28.3245929 C44.1328681,27.8918024 43.4234863,27.8918024 42.9906957,28.3245929 L29.0238246,42.2923099 C28.591034,42.7251004 27.8819342,42.7251004 27.4491436,42.2923099 L24.0090928,38.8525411 C23.5763022,38.4197505 22.8672024,38.4197505 22.4344118,38.8525411 L20.3245929,40.9634877 C19.8918024,41.3962783 19.8918024,42.1053782 20.3245929,42.5381687 L27.4491436,49.6613096 C27.8819342,50.0941002 28.591034,50.0941002 29.0238246,49.6613096 L46.6751956,32.0090928 C47.1082681,31.5760203 47.1082681,30.8672024 46.6751956,30.4341298 L44.5653768,28.3245929 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.74f1bbda.svg";
export { ForwardRef as ReactComponent };